var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftActive = function SvgLeftActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36ABFF",
    fillRule: "evenodd",
    d: "M9.756 7.256a.833.833 0 1 0-1.179-1.179L5.244 9.411a.833.833 0 0 0 0 1.178l3.333 3.334a.833.833 0 0 0 1.179-1.179l-1.91-1.91h6.32a.833.833 0 0 0 0-1.667h-6.32l1.91-1.911Z",
    clipRule: "evenodd"
  })));
};
export default SvgLeftActive;